export class PageRequest implements Data.Paginated {
  readonly pageNumber: number = 1
  readonly totalCount: number = 1
  readonly pageSize: number = 24
  readonly hasPreviousPage: boolean = false
  readonly hasNextPage: boolean = false
}
